// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
/**
 * 任务明细 DTO类
 * 任务明细
 */
export class TaskDataDTO {
  /** 流水线id : 流水线id */
  private _pipelineId: number;

  /** 设置：流水线id */
  public get pipelineId() {
    return this._pipelineId;
  }

  /** 获取：流水线id */
  public set pipelineId(value: number) {
    this._pipelineId = value;
  }

  /** 流水线名称 : 流水线名称 */
  private _pipelineName: string;

  /** 设置：流水线名称 */
  public get pipelineName() {
    return this._pipelineName;
  }

  /** 获取：流水线名称 */
  public set pipelineName(value: string) {
    this._pipelineName = value;
  }

  /** 步骤名称 : 步骤名称 */
  private _stageName: string;

  /** 设置：步骤名称 */
  public get stageName() {
    return this._stageName;
  }

  /** 获取：步骤名称 */
  public set stageName(value: string) {
    this._stageName = value;
  }

  /** 任务名称 : 任务名称 */
  private _taskName: string;

  /** 设置：任务名称 */
  public get taskName() {
    return this._taskName;
  }

  /** 获取：任务名称 */
  public set taskName(value: string) {
    this._taskName = value;
  }

  /** 构建数 : 构建数 */
  private _buildNumber: number;

  /** 设置：构建数 */
  public get buildNumber() {
    return this._buildNumber;
  }

  /** 获取：构建数 */
  public set buildNumber(value: number) {
    this._buildNumber = value;
  }

  /** 状态编码 : 状态编码(UNKOWN, RUNNING, WAITING, CANCELLING, CANCELED,FINISH,SUCCESS,FAIL,SKIP) */
  private _statusCode: string;

  /** 设置：状态编码 */
  public get statusCode() {
    return this._statusCode;
  }

  /** 获取：状态编码 */
  public set statusCode(value: string) {
    this._statusCode = value;
  }

  /** 状态名称 : 状态名称 */
  private _statusName: string;

  /** 设置：状态名称 */
  public get statusName() {
    return this._statusName;
  }

  /** 获取：状态名称 */
  public set statusName(value: string) {
    this._statusName = value;
  }

  /** 流水线地址 : 流水线地址 */
  private _pipelineUrl: string;

  /** 设置：流水线地址 */
  public get pipelineUrl() {
    return this._pipelineUrl;
  }

  /** 获取：流水线地址 */
  public set pipelineUrl(value: string) {
    this._pipelineUrl = value;
  }

  /** 消息 : 消息 */
  private _message: string;

  /** 设置：消息 */
  public get message() {
    return this._message;
  }

  /** 获取：消息 */
  public set message(value: string) {
    this._message = value;
  }

  constructor() {
    this._pipelineId = 0;
    this._pipelineName = '';
    this._stageName = '';
    this._taskName = '';
    this._buildNumber = 0;
    this._statusCode = '';
    this._statusName = '';
    this._pipelineUrl = '';
    this._message = '';
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    this.pipelineId = json.PipelineId;
    this.pipelineName = json.PipelineName;
    this.stageName = json.StageName;
    this.taskName = json.TaskName;
    this.buildNumber = json.BuildNumber;
    this.statusCode = json.StatusCode;
    this.statusName = json.StatusName;
    this.pipelineUrl = json.PipelineUrl;
    this.message = json.Message;
  }

  protected Serialize(json: any): void {
    json.PipelineId = this.pipelineId;
    json.PipelineName = this.pipelineName;
    json.StageName = this.stageName;
    json.TaskName = this.taskName;
    json.BuildNumber = this.buildNumber;
    json.StatusCode = this.statusCode;
    json.StatusName = this.statusName;
    json.PipelineUrl = this.pipelineUrl;
    json.Message = this.message;
  }

  static Create(json: any): TaskDataDTO {
    const taskDataDTO = new TaskDataDTO();
    taskDataDTO.Deserialize(json);
    return taskDataDTO;
  }
}
